import axios from 'axios'

export const getInformationsForProspect = (contact_id: string, type: string) => axios(`/api/sitel/contact/getAC?id_contact=${contact_id}&type=${type}`)
	.then((response) => response.data)

export const getInformationsForClient = (contact_id: string, type: string) => axios(`/api/sitel/contact/getGL?id_contact=${contact_id}&type=${type}`)
	.then((response) => response.data)